export default __webpack_public_path__ + "static/media/sunwsekiz8.552082cb.jpg";